import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { SignInCard } from "@/components/auth/sign-in-card";
import { PageContainer } from "@/components/primitives/layout";
import { auth } from "@/lib/auth";
import { getRequest } from "@tanstack/react-start/server";

const checkAuth = createServerFn({ method: "GET" }).handler(async () => {
  const request = getRequest();
  const session = await auth.api.getSession({ headers: request.headers });
  return { isAuthenticated: !!session };
});

export const Route = createFileRoute("/sign-in")({
  head: () => ({
    meta: [{ title: "Sign in - Scoopulator" }],
  }),
  beforeLoad: async () => {
    const { isAuthenticated } = await checkAuth();
    if (isAuthenticated) {
      throw redirect({ to: "/" });
    }
  },
  component: SignInPage,
});

function SignInPage() {
  return (
    <PageContainer>
      <section className="flex flex-col items-center">
        <SignInCard />
      </section>
    </PageContainer>
  );
}
